export default defineNuxtPlugin((nuxtApp) => {
  const reloadKey = 'chunk-error-reloaded';
  const reloadOnce = () => {
    const alreadyReloaded = sessionStorage.getItem(reloadKey);
    if (!alreadyReloaded) {
      sessionStorage.setItem(reloadKey, 'true');
      window.location.reload();
    }
  };

  nuxtApp.hook('app:chunkError', () => {
    console.warn('[ChunkErrorHandler] app:chunkError hook triggered');
    reloadOnce();
  });

  nuxtApp.hook('app:error', (error) => {
    const knownChunkErrors = [
      'error loading dynamically imported module',
      'Importing a module script failed',
      'Failed to fetch dynamically imported module',
    ];

    if (knownChunkErrors.some((msg) => error.message?.toLowerCase().includes(msg.toLowerCase()))) {
      console.warn('app:error hook trigered');
      console.warn('[ChunkErrorHandler] Reloading page due to failed chunk load.');
      reloadOnce();
    }
  });

  if (typeof window !== 'undefined') {
    window.addEventListener(
      'error',
      (event) => {
        const target = event?.target as HTMLElement | null;

        const isScriptOrStyle =
          (target?.tagName === 'SCRIPT' && (target as HTMLScriptElement).src.includes('/_nuxt/')) ||
          (target?.tagName === 'LINK' && (target as HTMLLinkElement).href.includes('/_nuxt/'));

        if (!isScriptOrStyle) return;

        reloadOnce();
      },
      true,
    );
  }
});
